import React from 'react';
import { useReveal } from '../lib/useReveal';
export function StatsBar() {
  const [ref1, vis1] = useReveal();
  return <section className="bg-[#3d2a5f] py-6 border-y border-[#4d3a6f] relative z-20" data-id="element-453">
      <div className="container mx-auto px-5" data-id="element-454">
        <div ref={ref1} className={`reveal flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-455">
          <div className="flex items-center gap-2" data-id="element-456">
            <span className="text-[#c9a14d] font-bold text-xl" data-id="element-457">+500</span>
            <span className="text-white/80 text-sm uppercase tracking-wider font-medium" data-id="element-458">
              personas ya lo tienen
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-459"></div>
          <div className="flex items-center gap-2" data-id="element-460">
            <span className="text-[#c9a14d] font-bold text-xl" data-id="element-461">6</span>
            <span className="text-white/80 text-sm uppercase tracking-wider font-medium" data-id="element-462">
              Tomos completos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-463"></div>
          <div className="flex items-center gap-2" data-id="element-464">
            <span className="text-[#c9a14d] font-bold text-xl" data-id="element-465">6</span>
            <span className="text-white/80 text-sm uppercase tracking-wider font-medium" data-id="element-466">
              Bonos incluidos
            </span>
          </div>
          <div className="hidden md:block w-px h-8 bg-white/10" data-id="element-467"></div>
          <div className="flex items-center gap-2" data-id="element-468">
            <span className="text-[#c9a14d] font-bold text-xl" data-id="element-469">4.9/5</span>
            <span className="text-white/80 text-sm uppercase tracking-wider font-medium" data-id="element-470">
              calificación ⭐
            </span>
          </div>
        </div>
      </div>
    </section>;
}